 
import { Mixin } from 'mixwith';
import { ElementNodeBuilder } from 'Editor/services/Model';
import { Logger } from '_common/services';
import { ELEMENTS } from 'Editor/services/consts';

export default Mixin(
  (superclass) =>
    class extends superclass {
      parseCitationGroupNode(representation) {
        const builder = new ElementNodeBuilder();

        const mapper = this.editorContext.visualizerManager
          .getViewFactory()
          ?.getAttributeMapper(ELEMENTS.CitationsGroupElement.ELEMENT_TYPE);

        Object.keys(mapper).forEach((prop) => {
          try {
            mapper[prop].parse(representation, builder);
          } catch (e) {
            Logger.captureException(e);
          }
        });

        this.parseChildren(representation, builder);

        return builder.getNode();
      }

      parseCitation(representation) {
        const builder = new ElementNodeBuilder();

        const mapper = this.editorContext.visualizerManager
          .getViewFactory()
          ?.getAttributeMapper(ELEMENTS.CitationElement.ELEMENT_TYPE);

        Object.keys(mapper).forEach((prop) => {
          try {
            mapper[prop].parse(representation, builder);
          } catch (e) {
            Logger.captureException(e);
          }
        });

        this.parseChildren(representation, builder);

        return builder.getNode();
      }
    },
);
